// ... existing code ...

import { Box } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import UnitInfoModal from "./UnitInfoModal.js";

// 크로스 테이블 스타일 컴포넌트 추가
export default function CrossTable({ selectedLot, receivedData }) {
  const [unitList, setUnitList] = useState([]);
  const [ngCountList, setNgCountList] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const categories = ["Location (x,y)", "NG/Total"];
  const [openModal, setOpenModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  useEffect(() => {
    const filteredData = receivedData.filter(
      (item) => item.lot === selectedLot
    );
    setUnitList(filteredData.map((item, index) => index));
    setNgCountList(filteredData.map((item) => item.count));
    setLabelList(filteredData.map((item) => item.label));
    setLocationList(filteredData.map((item) => item.location));
  }, [receivedData, selectedLot]);

  const onHeaderClick = (unit) => {
    console.log(receivedData[unit]);
    // setOpenModal(true);
    // setSelectedData(receivedData[unit]);
  };

  // useEffect(() => {
  //   console.log("receivedData", receivedData);
  // }, [receivedData]);

  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `auto repeat(${unitList.length}, 1fr)`,
          gap: "1px",
          backgroundColor: "var(--lot-table-bg)",
          "& > div": {
            backgroundColor: "white",
            padding: "8px",
            minWidth: "100px",
            textAlign: "center",
          },
          "& .header": {
            backgroundColor: "var(--lot-header-bg)",
            color: "var(--lot-header-color)",
            fontWeight: "bold",
          },
          "& .row-header": {
            backgroundColor: "var(--lot-header-bg)",
            color: "var(--lot-header-color)",
            fontWeight: "bold",
            minWidth: "120px",
          },
          overflowX: "auto",
        }}
      >
        <div className="header">구분</div>
        {unitList.map((unit) => (
          <div
            key={unit}
            className="header"
            // onClick={() => onHeaderClick(unit)}
            // style={{ cursor: "pointer" }}
          >
            Unit {unit + 1}
          </div>
        ))}

        {categories.map((rowHeader) => (
          <Fragment key={rowHeader}>
            <div className="row-header">{rowHeader}</div>
            {unitList.map((unit, index) => (
              <div
                key={`${rowHeader}-${unit}`}
                style={{
                  color: "var(--lot-table-color)",
                  backgroundColor: "var(--lot-table-bg)",
                }}
              >
                {rowHeader === "NG/Total"
                  ? `${
                      receivedData[unit].types
                        .split(",")
                        .filter((type) => type.trim() === "NG").length
                    }/${receivedData[unit].types.split(",").length}`
                  : rowHeader === "Location (x,y)"
                  ? `(${locationList[index]})`
                  : "-"}
              </div>
            ))}
          </Fragment>
        ))}
      </Box>
      <UnitInfoModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        selectedData={selectedData}
      />
    </>
  );
}
